<template>
  <button class="confirmation__close" @click="closeErrorDialog">
    <IconClose aria-label="Dialog schließen" />
  </button>
  <p class="confirmation__subtitle">
    Sie haben zu dieser Zeit bereits einen Termin - Bitte fügen Sie die Dienstleistung zur
    bestehenden Buchung dazu oder wählen Sie eine andere Uhrzeit.
  </p>
  <div class="confirmation__button">
    <Button label="Okay" @clicked="closeErrorDialog" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import IconClose from '@/components/icons/IconClose.vue'

export default {
  components: { IconClose, Button },
  emits: ['closeErrorDialog'],
  methods: {
    closeErrorDialog() {
      this.$emit('closeErrorDialog')
    },
  },
}
</script>

// css comes from delete dialog
